import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import clockImage from "../assets/images/clock.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 700,
    },
  })
);

export default function Loading() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img src={clockImage} alt="loading" width="100" />
    </div>
  );
}
